import { useContext } from 'react';
import { WorkQueueContext } from './WorkQueueContext.js';

/** Access the Work Queue context; throws if used outside its provider. */
export function useWorkQueueContext() {
  const ctx = useContext(WorkQueueContext);
  if (!ctx) {
    throw new Error('useWorkQueueContext must be used within a WorkQueueProvider');
  }
  return ctx;
}
